import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { css } from '@emotion/css';
import { formatPrice } from '../../utils/formatString';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { DriverTipType } from '../../utils/constants';

const tipOptionsStyle = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
  min-width: 72px;
  width: 100%;
  padding: 0.375rem 0 0.375rem 0.5rem;
  line-height: 20.3px;
  border-radius: 8px;
  border: 1px solid #e5e4e3;

  div {
    font-size: 0.875rem;
    font-weight: 600;
  }
  p {
    font-size: 0.875rem;
    font-weight: 400;
    margin: 0;
  }
`;

const addPadding = css`
  padding: 0.5rem;
`;

// need to add this class condtionally when tipOptionList length is 1
const oneTipOptionStyle = css`
  height: 60.6px;
`;
const tipOptionActiveStyle = css`
  background-color: #1f1e1e;
  color: #ffffff;
`;

const noTipOptionsStyle = css`
  display: flex;
  justify-content: center;
  white-space: nowrap;
`;

const customTipContainerStyle = css`
  display: flex;
  width: 151px ;
 
div{
  display: flex;
  width: 100%;
  button {
  align-self: center;
  height: 20px;
  width: 35px;
  margin: 0;
  padding: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5em;
  text-decoration: underline;
  border: none;
  cursor: pointer;
  color: #1F1E1E; 
  background: none;

  @media (max-width: 641px) {
    padding: 0;
  }
  }
`;

const customTipStyle = css`
  display: flex;
  align-items: flex-start;
  padding: 7px 1rem !important;
  justify-content: space-between;
`;

const customTipInitialStyle = css`
  padding: 1.05rem 0 !important;
  justify-content: center;
`;

const customFormInputStyle = css`
  @media (max-width: 641px) {
    width: 100%;
    min-width: fit-content;
  }
`;

const customTipEditLabelStyle = css`
  font-size: 12px;
  font-weight: 400;
  color: #6e6e6d;
  line-height: 17.4px;
  margin-bottom: 0;
`;

const formError = css`
  border: 1px solid #b00000;
  label {
    color: #b00000;
  }
`;

const customTipEditStyle = css`
  @media (max-width: 641px) {
    width: auto !important;
    align-items: normal;
  }
`;

// need to add this class condtionally when tipOptionList length is 1
const oneOptionCustomTipEditStyle = css`
  @media (max-width: 641px) {
    flex: 3;
  }
`;

const customTipEditBorderStyle = css`
  border: 2px solid #1f1e1e !important;
`;

const customTipDoneStyle = css`
  color: #ffffff !important;
  background-color: #1f1e1e;
`;

const customTipDoneDisableStyle = css`
  color: #6e6e6d !important;
  cursor: default !important;
`;

const inputContainerStyle = css`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;

const dollarStyle = css`
  font-size: 16px;
  font-weight: 400;
  line-height: 23.2px;
`;

const inputStyle = css`
  border: none;
  outline: none;
  font-size: 14px;
  font-weight: 400;
  line-height: 23.2px;
  width: 95% !important;
  opacity: 1;
`;

const customTipErrorContainer = css`
  display: flex;
  margin-left: 1rem;

  p.customTipErrorInfo {
    color: #b00000;
    margin-left: 4px;
    font-size: 12px;
    font-weight: 400;
    line-height: 17.4px;
    width: 158px;
    text-align: left;

    @media (max-width: 641px) {
      width: auto;
    }
  }

  @media (max-width: 641px) {
    // width: auto !important ;
    justify-content: center;
  }
`;

const customOneTipOptionStyle = css`
  width: 100%;
  div.customTipErrorContainer {
    margin-top: 0.5rem;
  }
`;
const fullWidthCustomTipErrorText = css`
  @media (max-width: 641px) {
    width: fit-content !important;
  }
`;

type CustomTipType = 'edit' | 'done' | 'initial';

export enum CustomTipMode {
  EDIT = 'edit',
  DONE = 'done',
  INITIAL = 'initial',
}

const errorMesageIcon = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_8690_32027)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.25 8.00098C0.25 3.72077 3.71979 0.250977 8 0.250977C12.2802 0.250977 15.75 3.72077 15.75 8.00098C15.75 12.2812 12.2802 15.751 8 15.751C3.71979 15.751 0.25 12.2812 0.25 8.00098ZM4.75 7.00098C4.19772 7.00098 3.75 7.44869 3.75 8.00098C3.75 8.55326 4.19772 9.00098 4.75 9.00098H11.25C11.8023 9.00098 12.25 8.55326 12.25 8.00098C12.25 7.44869 11.8023 7.00098 11.25 7.00098H4.75Z"
        fill="#B00000"
      />
    </g>
    <defs>
      <clipPath id="clip0_8690_32027">
        <rect width="16" height="16" fill="white" transform="translate(0 0.000976562)" />
      </clipPath>
    </defs>
  </svg>
);

export const TipOptions = (props) => {
  const index = get(props, 'index', '');
  const tipPercentage = get(props, 'tipPercentage', '');
  const tipRoundedAmount = get(props, 'tipRoundedAmount', '');

  const className = get(props, 'className', '');
  const tabType = get(props, 'tabType', '');
  const driverTipOptionSelected = get(props, 'driverTipOptionSelected', '');
  const setDriverTipOptionSelected = get(props, 'setDriverTipOptionSelected', () => {});
  const setDriverTipRoundedAmountSelcted = get(props, 'setDriverTipRoundedAmountSelcted', () => {});
  const isCustomTipSelected = get(props, 'isCustomTipSelected', false);
  const setIsCustomTipValid = get(props, 'setIsCustomTipValid', () => {});
  const setIsCustomTipSelected = get(props, 'setIsCustomTipSelected', () => {});
  const setShowDriverTipModal = get(props, 'setShowDriverTipModal', () => {});
  const isDriverTipPreferenceSet = get(props, 'isDriverTipPreferenceSet', false);
  const tipOptionsList = get(props, 'tipOptionsList', []);
  const hasCustomTipError = get(props, 'hasCustomTipError', false);

  useEffect(() => {
    // If we want to ensure that "Other" is selected whenever isCustomTipSelected is true:
    if (isCustomTipSelected && driverTipOptionSelected !== DriverTipType.PREFERENCES_OTHER) {
      setDriverTipOptionSelected(DriverTipType.PREFERENCES_OTHER);
    }
  }, [isCustomTipSelected, driverTipOptionSelected, setDriverTipOptionSelected, setDriverTipRoundedAmountSelcted]);

  const handleTipOptionsOnClick = () => {
    //Prevent re-selecting the same tip
    if (driverTipOptionSelected === tipPercentage && !isCustomTipSelected) {
      return;
    }

    // Possibly show a confirmation modal if no preference is set
    setShowDriverTipModal(true);

    // If they clicked a numeric tip or "noTip," we turn off custom tips
    // If they clicked "Other," we turn on custom tips (handled below)
    setDriverTipOptionSelected(tipPercentage);
    setDriverTipRoundedAmountSelcted(formatPrice(tipRoundedAmount));
    //setIsCustomTipValid(false);
    setIsCustomTipSelected(tipPercentage === DriverTipType.PREFERENCES_OTHER);
  };

  // Decide if this tip should get the "active" class
  const isActive = () => {
    if (isCustomTipSelected && tipPercentage === DriverTipType.PREFERENCES_OTHER) {
      return true;
    }
    if (!isCustomTipSelected && driverTipOptionSelected === tipPercentage) {
      return true;
    }
    return false;
  };

  return (
    <div
      onClick={handleTipOptionsOnClick}
      className={`
        ${tipPercentage === DriverTipType.NOTIP ? className : ''} 
        ${tipOptionsStyle}
        ${tabType === 'preferences' ? addPadding : ''} 
        ${isActive() ? tipOptionActiveStyle : ''}  
        ${tipOptionsList.length === 1 && hasCustomTipError ? oneTipOptionStyle : ''}
        `}
      key={index}
    >
      <div>
        <div
          className={`
          body-text label
          ${tipPercentage === DriverTipType.NOTIP ? noTipOptionsStyle : ''}
        `}
        >
          {tipPercentage === DriverTipType.NOTIP ? 'No tip' : `${tipPercentage}%`}
        </div>

        {tipRoundedAmount > 0 && <p className="body-text amount">${formatPrice(tipRoundedAmount)}</p>}
      </div>
    </div>
  );
};

TipOptions.propTypes = {
  index: PropTypes.any,
  tipPercentage: PropTypes.string,
  tipSelected: PropTypes.bool,
  className: PropTypes.string,
  tabType: PropTypes.string,
  isCustomTipSelected: PropTypes.bool,
  setIsCustomTipSelected: PropTypes.func,
  tipRoundedAmount: PropTypes.number,
  selectedTipValue: PropTypes.string,
  driverTipOptionSelected: PropTypes.string,
  setDriverTipOptionSelected: PropTypes.func,
  setShowDriverTipModal: PropTypes.func,
  isDriverTipPreferenceSet: PropTypes.bool,
  setDriverTipPreferenceSet: PropTypes.func,
  setIsCustomTipValid: PropTypes.func,
  setDriverTipRoundedAmountSelected: PropTypes.func,
  tipOptionsList: PropTypes.array,
  hasCustomTipError: PropTypes.bool,
  customTipModeType: PropTypes.string,
};

const CustomTipContainer = (props) => {
  const tabType = get(props, 'tabType', '');
  const tipOptionsList = get(props, 'tipOptionsList', '');
  const customTipMode = get(props, 'customTipMode', '');
  const children = get(props, 'children', '');
  return tabType === 'preferences' ? (
    <>{children}</>
  ) : (
    <div
      className={`
          ${tipOptionsList.length === 1 ? customOneTipOptionStyle : ''}
          ${tabType === 'upcomingOrder' && tipOptionsList.length === 1 && customTipMode === CustomTipMode.EDIT ? oneOptionCustomTipEditStyle : ''}
          `}
    >
      {children}
    </div>
  );
};

export const CustomTip = (props) => {
  const [customTipMode, setCustomTipMode] = useState<CustomTipType>('initial');
  const [hasClickedDone, setHasClickedDone] = useState(false);
  const className = get(props, 'className', '');
  const isCustomTipSelected = get(props, 'isCustomTipSelected', '');
  const setIsCustomTipSelected = get(props, 'setIsCustomTipSelected', () => {});
  const driverCustomTipValue = get(props, 'driverCustomTipValue', '');
  const setDriverCustomTipValue = get(props, 'setDriverCustomTipValue', () => {});
  const driverTipOptionSelected = get(props, 'driverTipOptionSelected', '');
  const fullWidthCustomTip = get(props, 'fullWidthCustomTip', false);
  const customTipHandler = get(props, 'customTipHandler', () => {});
  const orderTotal = get(props, 'orderTotal', 0);
  const tabType = get(props, 'tabType', '');
  const setCustomTipModeType = get(props, 'setCustomTipModeType', () => {});
  const isUpcomingOrder = get(props, 'isUpcomingOrder', false);
  const customTipEditMode = get(props, 'customTipEditMode', false);
  const setCustomTipEditMode = get(props, 'setCustomTipEditMode', () => {});
  const isCustomTipValid = get(props, 'isCustomTipValid', false);
  const setIsCustomTipValid = get(props, 'setIsCustomTipValid', () => {});
  const showSavePreferenceButton = get(props, 'showSavePreferenceButton', true);
  const setShowSavePreferenceButton = get(props, 'setShowSavePreferenceButton', () => {});
  const tipOptionsList = get(props, 'tipOptionsList', []);
  const setHasCustomTipError = get(props, 'setHasCustomTipError', () => {});

  interface IFormInput {
    customTipValue: string;
  }

  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    setValue,
    setError,
    setFocus,
    clearErrors,
  } = useForm<IFormInput>({
    defaultValues: {
      customTipValue: driverCustomTipValue,
    },
    mode: 'onChange', // Enables validation on change
  });

  useEffect(() => {
    if (driverCustomTipValue !== '' && isCustomTipSelected) {
      setHasClickedDone(true);
      setValue('customTipValue', driverCustomTipValue);
      setCustomTipMode(CustomTipMode.DONE);
    } else {
      setValue('customTipValue', '');
    }
  }, []);

  useEffect(() => {
    if (customTipEditMode) {
      setCustomTipMode(CustomTipMode.EDIT);
      setTimeout(() => setFocus('customTipValue'), 0);
    }
  }, [customTipEditMode, setFocus]);

  useEffect(() => {
    if (customTipMode === CustomTipMode.DONE)
      errors.customTipValue?.message ? setIsCustomTipValid(false) : setIsCustomTipValid(true); // TODO: Need to verify if this is correct
  }, []);

  useEffect(() => {
    setCustomTipModeType(customTipMode);
  }, [customTipMode]);

  useEffect(() => {
    if (!isCustomTipSelected) {
      setCustomTipMode(CustomTipMode.INITIAL);
      setValue('customTipValue', driverCustomTipValue);
      clearErrors('customTipValue');
    }
  }, [isCustomTipSelected, driverTipOptionSelected]);

  useEffect(() => {
    if (errors.customTipValue?.message) {
      setHasCustomTipError(true);
    } else {
      setHasCustomTipError(false);
    }
  }, [errors?.customTipValue?.message]);

  const handleCustomTipOnClick = () => {
    setCustomTipMode(CustomTipMode.EDIT);
    setTimeout(() => setFocus('customTipValue'), 0);
  };

  const handleCustomTipOnSubmit = (data) => {
    if (customTipMode === CustomTipMode.DONE) {
      setCustomTipMode(CustomTipMode.EDIT);
      setTimeout(() => setFocus('customTipValue'), 0);
    } else if (customTipMode === CustomTipMode.EDIT) {
      setHasClickedDone(true);
      setCustomTipMode(CustomTipMode.DONE);
      setIsCustomTipSelected(true);
      setCustomTipEditMode(false);
      setFocus('customTipValue');
      setDriverCustomTipValue(data.customTipValue);

      customTipHandler(parseFloat(data.customTipValue));
    }
  };

  const handleCustomTipOnChange = (e) => {
    const value = e.target.value;
    setValue('customTipValue', value);

    if (!/^\d+(\.\d{1,2})?$/.test(value)) {
      setError('customTipValue', {
        type: 'invalidFormat',
        message: 'Only numbers and single decimal point are allowed.',
      });
      setIsCustomTipValid(false);
      return;
    }

    const enteredAmount = parseFloat(value);

    if (isUpcomingOrder) {
      if (enteredAmount > orderTotal || enteredAmount > 99.99) {
        setError('customTipValue', {
          type: 'max',
          message: 'Tip can’t exceed $99.99 or the order total.',
        });
        return;
      }
    }

    if (!isUpcomingOrder && enteredAmount > 99.99) {
      setError('customTipValue', {
        type: 'max',
        message: 'Tip can’t exceed $99.99 or the order total.',
      });
      setShowSavePreferenceButton(false);
      setIsCustomTipValid(false);
      return;
    } else if (enteredAmount < 0.01) {
      setError('customTipValue', {
        type: 'min',
        message: 'Tip must be at least $0.01.',
      });
      setIsCustomTipValid(false);
      setShowSavePreferenceButton(false);
      return;
    } else {
      clearErrors('customTipValue');
      setShowSavePreferenceButton(true);
    }
    setIsCustomTipValid(true);
  };

  const handleCustomInputBlur = (event) => {
    const newFocusTarget = event.relatedTarget;

    if (get(newFocusTarget, 'id') === 'customTipDone') return;

    const value = getValues('customTipValue');

    if (!hasClickedDone && value === '') {
      setCustomTipMode(CustomTipMode.INITIAL);
      setValue('customTipValue', '');
      setDriverCustomTipValue('');
      clearErrors('customTipValue');
      setIsCustomTipSelected(false);
    }
  };

  return (
    <CustomTipContainer tabType={tabType} tipOptionsList={tipOptionsList} customTipMode={customTipMode}>
      <div
        className={`${className} 
        ${tipOptionsStyle} 
        ${customTipContainerStyle} 
        ${customTipMode === CustomTipMode.EDIT && fullWidthCustomTip ? customTipEditStyle : ''} 
        ${customTipMode === CustomTipMode.EDIT ? customTipEditBorderStyle : ''} 
        ${customTipMode === CustomTipMode.DONE ? customTipDoneStyle : ''} 
        ${errors?.customTipValue?.message ? formError : ''}`}
      >
        {customTipMode !== CustomTipMode.INITIAL ? (
          <>
            <form
              className={customFormInputStyle}
              data-testid="custom-tip-form"
              onSubmit={handleSubmit(handleCustomTipOnSubmit)}
            >
              <div className={customTipStyle}>
                <div className={inputContainerStyle}>
                  <label
                    className={`${customTipEditLabelStyle} ${customTipMode === CustomTipMode.DONE ? customTipDoneStyle : ''}`}
                  >
                    Custom tip
                  </label>
                  <div>
                    <span className={dollarStyle}>$</span>
                    <input
                      {...register('customTipValue', {
                        required: 'Tip amount is required',
                      })}
                      id="customTipValue"
                      data-testid="custom-tip-Input"
                      autoComplete="off"
                      disabled={customTipMode === CustomTipMode.DONE}
                      className={`${inputStyle} ${customTipMode === CustomTipMode.DONE ? customTipDoneStyle : ''}`}
                      onChange={handleCustomTipOnChange}
                      onBlur={errors.customTipValue?.message ? undefined : handleCustomInputBlur}
                    />
                  </div>
                </div>
                <button
                  type="submit"
                  className={`${customTipMode === CustomTipMode.DONE ? customTipDoneStyle : ''} ${getValues('customTipValue') === '' || errors?.customTipValue ? customTipDoneDisableStyle : ''} link-sm`}
                  disabled={getValues('customTipValue') === '' || !!errors?.customTipValue}
                >
                  {customTipMode === CustomTipMode.EDIT ? 'Done' : 'Edit'}
                </button>
              </div>
            </form>
          </>
        ) : (
          <div
            data-testid="custom-tip-initial"
            className={`body-text label ${customTipInitialStyle}`}
            onClick={handleCustomTipOnClick}
          >
            Custom tip
          </div>
        )}
      </div>
      {errors.customTipValue?.message && (
        <div
          data-testid="custom-tip-error"
          className={`${customTipErrorContainer} ${fullWidthCustomTip ? fullWidthCustomTipErrorText : ''} ${className} 'customTipErrorContainer'`}
        >
          {errorMesageIcon}
          <p className="customTipErrorInfo">{errors.customTipValue?.message}</p>
        </div>
      )}
    </CustomTipContainer>
  );
};
